import React from 'react';
import {
  faPhone,
  faMapMarker,
  faCopyright,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Logo } from '../layout/Logo';

export const Footer = ({ className = '' }) => {
  return (
    <footer className={`py-5 FooterHeaderBackgroundImage ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <div className="text-center mb-3">
              <Logo alt="logo-footer" className="img-fluid" />
            </div>
            <div className="text-right">
              <p style={{ color: 'rgb(204,230,187)' }}>
                <FontAwesomeIcon icon={faMapMarker} /> فارس، شیراز  
              </p>
              <p style={{ color: 'rgb(204,230,187)' }}>
                <FontAwesomeIcon icon={faPhone} /> تلفن: 071100000 (10 خط)
              </p>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <h5 style={{ color: 'rgb(255,255,255)' }} className="mb-3">
              خدمات
            </h5>
            <ul className="list-unstyled">
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  مشاوره
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  عمل جراحی
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  خدمات تشخیصی
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <h5 style={{ color: 'rgb(255,255,255)' }} className="mb-3">
              دکتر زنان و زایمان
            </h5>
            <ul className="list-unstyled">
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  رزومه
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  افتخارات
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  مقالات
                </a>
              </li>
            </ul>
          </div>
          <div className="col-12 col-sm-6 col-lg-3 mb-4">
            <h5 style={{ color: 'rgb(255,255,255)' }} className="mb-3">
              دسترسی سریع
            </h5>
            <ul className="list-unstyled">
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  تماس با ما
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  نوبت دهی اینترنتی
                </a>
              </li>
              <li>
                <a
                  className={'text-decoration-none'}
                  style={{ color: 'rgb(204,230,187)' }}
                  href="#"
                >
                  همکاری با ما
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={'d-flex align-items-center flex-column'}>
        <div>
          <p className="mb-1 text-white">تمامی حقوق محفوظ است.</p>
        </div>
        <p className="mb-0 text-white">
              <a
            href="#"
            className="text-white text-decoration-none"
          >
           
          </a>
        </p>
      </div>
    </footer>
  );
};
